import { useRouter } from "@tanstack/react-router";
import type { DateRange } from "react-day-picker";

export function requireDateRange(
  dateRange: DateRange
): { from: Date; to: Date } | null {
  const { from, to } = dateRange;
  if (from && to) {
    return { from, to };
  }
  return null;
}

export const useSearchParamsDateRange = (): [
  DateRange,
  (from: Date, to: Date) => void,
] => {
  const router = useRouter();
  const searchParams = new URLSearchParams(window.location.search);

  const fromParam = searchParams.get("from");
  const toParam = searchParams.get("to");

  const dateRange: DateRange = {
    from: fromParam ? new Date(fromParam) : undefined,
    to: toParam ? new Date(toParam) : undefined,
  };

  const setDateRange = (from: Date, to: Date) => {
    const newSearchParams = new URLSearchParams(window.location.search);
    newSearchParams.set("from", from.toISOString());
    newSearchParams.set("to", to.toISOString());

    const newUrl = `${window.location.pathname}?${newSearchParams.toString()}`;
    window.history.replaceState({}, "", newUrl);

    // Notify router of the change - intentionally not awaiting
    void router.invalidate();
  };

  return [dateRange, setDateRange];
};
